import { render, staticRenderFns } from "./ComandaNoua.vue?vue&type=template&id=0f10ade0&scoped=true"
import script from "./ComandaNoua.vue?vue&type=script&lang=js"
export * from "./ComandaNoua.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f10ade0",
  null
  
)

export default component.exports